// extracted by mini-css-extract-plugin
export default {"view":"audience_view__9kRUE","wrapper":"audience_wrapper__ivos5","rightAlign":"audience_rightAlign__xUBwR","editorRow":"audience_editorRow__LefiY"};